import { render, staticRenderFns } from "./CustomerMassageAutoComplete.vue?vue&type=template&id=28e9b91a&scoped=true&"
import script from "./CustomerMassageAutoComplete.vue?vue&type=script&lang=js&"
export * from "./CustomerMassageAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9b91a",
  null
  
)

export default component.exports